<template>
  <dl class="boss-scoutandlike-item-list-item">
    <dt
      :class="{ 'boss-new': hasUnread }"
      class="boss-scoutandlike-item-list-head boss-scoutandlike-item-list-recommend"
      data-alignment="center"
    >
      <div class="boss-scoutandlike-item-list-title">
        <span
          :class="iconName"
          class="boss-icon"
        />
        <span>{{ title }}
          <span
            v-if="tooltip"
            v-tooltip="{ content: tooltip}"
            class="pega-circle"
          >?
          </span>
        </span>
      </div>
    </dt>
    <dd
      class="boss-scoutandlike-item-list-body"
      :class="{ 'tall' : isTall, 'notice-background': noticeBackground }"
    >
      <div class="boss-scoutandlike-item-list-text">
        <slot />
      </div>
    </dd>
  </dl>
</template>

<style scoped>
.pega-circle {
  cursor: pointer;
  font-size: .7em;
}
</style>
<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    hasUnread: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: ''
    },
    isTall: {
      type: Boolean,
      default: false
    },
    noticeBackground: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconName () {
      return 'boss-icon-' + this.name
    }
  }
}
</script>
